<form [formGroup]="appraisalModalForm" (ngSubmit)="accepted()">
  @if (!hasAppraisal) {
    <div class="checkbox">
      <!-- <p class="info-text small">
              {{ 'appraisal_modal_msg_1' | translate }}
          </p>
  
  
          <p class="info-text small">
              {{ 'appraisal_modal_msg_2' | translate }}
          </p>
  
          <p class="info-text appraisal-cost" [innerHTML]="'appraisal_modal_msg_cost' | translate:{'costAppraisal': appraisalCost | number: '1.2-2'}">
  
          </p>
  
          <p class="info-text small">
              {{ 'appraisal_modal_msg_4' | translate }}
  
          </p> -->
      <p
        class="info-text"
        [innerHTML]="'appraisal_modal_msg_cost' | translate: { costAppraisal: appraisalCost | number: '1.2-2' }"
      ></p>
      <input type="checkbox" id="appraisal-modal-acepted-condition" formControlName="condition" />
      <label id="appraisal-modal-label-acepted-condition" for="appraisal-modal-acepted-condition">
        {{ 'appraisal_modal_accept_account_charge' | translate }}</label
      >
    </div>
  } @else {
    <ng-template #hasAppraisalTemplate>
      <div class="checkbox">
        <p class="info-text">{{ 'appraisal_modal_info_1' | translate }}</p>
        <p class="info-text">{{ 'appraisal_modal_info_2' | translate }}</p>
      </div>
    </ng-template>
  }
</form>

<div class="form-btn-group col-12 no-pd d-flex justify-content-end">
  <button id="appraisal-modal-btn-later" class="btn btn-01" (click)="cancel()">
    {{ 'appraisal_modal_btn_later' | translate }}
  </button>
  <button
    id="appraisal-modal-btn-send"
    class="btn btn-02"
    [disabled]="!hasAppraisal && !appraisalModalForm.controls.condition.value"
    (click)="accepted()"
  >
    {{ 'appraisal_modal_btn_now' | translate }}
  </button>
</div>
